import {Observable} from 'rxjs';
import {SignInCredentials} from '@/models/user.model';
import {map, retry} from 'rxjs/operators';
import {AuthenticatedModel} from '@/models/authenticated.model';
import {
  API_URL,
  AUTH_URL,
  axiosInstance,
  axiosInstanceAuthenticated,
  CLIENT_ID,
  CLIENT_SECRET
} from '@/api/axios.config.api';
import {ForgotPasswordModel} from '@/models/forgot-password.model';

export class AuthApi {
  private readonly url: string = AUTH_URL.href;
  private readonly urlApi: string = API_URL.href;

  signIn(credentials: SignInCredentials): Observable<AuthenticatedModel> {
    const data = {
      ...credentials,
      client_secret: CLIENT_SECRET,
      client_id: CLIENT_ID,
      grant_type: 'password',
    };
    return axiosInstance().post<AuthenticatedModel>(this.url, data)
      .pipe(
        map((response) => {
          localStorage.setItem('credentials', JSON.stringify(response.data));
          return response.data
        }),
      )
  }

  signInWithSocial(
    access_token: string,
    provider: 'facebook' | 'linkedin' | 'google',
    accept_terms?: boolean): Observable<AuthenticatedModel> {
    const data = {
      provider,
      access_token,
      accept_terms,
      grant_type: 'social',
      client_secret: CLIENT_SECRET,
      client_id: CLIENT_ID,
    };
    return axiosInstance().post(this.url, data).pipe(
      map((response) => {
        localStorage.setItem('credentials', JSON.stringify(response.data));
        return response.data
      }),
    )
  }

  recoverPassword(data: { email: string }): Observable<{ type: string, message: string }> {
    return axiosInstance().post(`${this.urlApi}v1/password/email`, data)
      .pipe(
        retry(1),
        map((response) => response.data),
      )
  }

  resetPassword(data: ForgotPasswordModel): Observable<{ type: string, message: string }> {
    return axiosInstance().post(`${this.urlApi}v1/password/reset`, data)
      .pipe(
        retry(1),
        map((response) => response.data),
      )
  }

  confirmUser(token: string): Observable<AuthenticatedModel> {
    return axiosInstance().post(`${this.urlApi}v1/email/verify`, {token})
      .pipe(
        map((response) => {
          localStorage.setItem('credentials', JSON.stringify(response.data));
          return response.data
        })
      )
  }

  resendEmailVerify(): Observable<any> {
    return axiosInstanceAuthenticated().post(`me/resend-email-verify`)
      .pipe(map((response) => response.data))
  }
}
